import { render, staticRenderFns } from "./DetailSubPage.vue?vue&type=template&id=236869c8&scoped=true&"
import script from "./DetailSubPage.vue?vue&type=script&lang=ts&"
export * from "./DetailSubPage.vue?vue&type=script&lang=ts&"
import style0 from "./DetailSubPage.vue?vue&type=style&index=0&id=236869c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236869c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
